import { Droplets, Leaf, Award, Heart } from "lucide-react";
import { TrustBand } from "@/components/TrustBand";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="bg-navy hero-splash">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 text-center">
          <h1 className="font-display font-black text-white text-4xl md:text-5xl tracking-tighter">DESPRE DETERSHOP</h1>
          <p className="text-white/80 mt-4 max-w-2xl mx-auto text-lg">
            Curățenie profesională, rezultate impecabile. Detergenți lichizi concentrați fabricați în România,
            la un preț corect.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid sm:grid-cols-2 gap-8">
            {[
              { icon: Droplets, t: "Formulă concentrată", d: "Până la 400 de spălări dintr-un singur bidon de 5L. Mai puțin produs, mai multe rezultate." },
              { icon: Leaf, t: "Respectuos cu țesăturile", d: "Protejează fibrele hainelor tale, potrivit pentru albe și colorate deopotrivă." },
              { icon: Award, t: "Calitate garantată", d: "Produse testate și aprobate, fabricate cu standarde înalte în România." },
              { icon: Heart, t: "Mii de clienți mulțumiți", d: "Miros de lungă durată și curățenie profundă, alese de tot mai multe familii." },
            ].map(({ icon: Icon, t, d }) => (
              <div key={t} className="flex gap-4">
                <span className="bg-eco/10 rounded-2xl h-14 w-14 shrink-0 flex items-center justify-center">
                  <Icon className="h-7 w-7 text-eco" />
                </span>
                <div>
                  <h3 className="font-display font-black text-navy text-lg">{t}</h3>
                  <p className="text-sm text-muted-foreground mt-1">{d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <TrustBand />
    </div>
  );
}
